import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { processQueue } from 'src/utils/queueProcessor';

const useQueueProcessor = () => {
  const queue = useSelector((state) => state.queue);
  const dispatch = useDispatch();

  useEffect(() => {
    processQueue(queue, dispatch);
  }, [queue, dispatch]);
};

export default useQueueProcessor;
